import { addDays, isBefore } from 'date-fns';

import { CalendarType, DatePickerDate } from '../types';

export default function isBackwardDisabled({
  calendars,
  minDate,
}: {
  calendars: Pick<CalendarType, 'firstDayOfMonth'>[];
  minDate?: DatePickerDate | null;
}) {
  if (!minDate) {
    return false;
  }

  const { firstDayOfMonth } = calendars[calendars.length - 1];
  const lastDayOfMonthPlusOne = addDays(firstDayOfMonth, -1);

  if (isBefore(lastDayOfMonthPlusOne, minDate)) {
    return true;
  }

  return false;
}
